import axios from 'axios'
import { useCallback, useEffect, useState } from 'react'

import { SubjectOwnership } from '../../common/subjectTypes'
import { AsyncState } from '../../redux/fetchAction'
import { useAppSelector } from '../../redux/hooks'

export const useFetchSubjectOwnership = (
  subjectId?: string,
  searchHistory?: boolean
) => {
  const { token } = useAppSelector(state => state.myProfile)

  const [state, setState] = useState<AsyncState<SubjectOwnership[]>>({
    fetching: true,
    data: null,
    error: false,
  })

  const fetchSubjectOwnership = useCallback(async () => {
    if (!subjectId || !token) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
      return
    }

    setState({
      fetching: true,
      data: null,
      error: false,
    })

    try {
      const response = await axios.get<SubjectOwnership[]>(
        `https://data.regesta.cz/DrmApi/api/v1.0/Subjekty/${subjectId}/VlastnickaPrava?vcetneHistorie=${!!searchHistory}&access_token=${token}`
      )
      setState({
        fetching: false,
        data: response.data,
        error: false,
      })
    } catch (error) {
      setState({
        fetching: false,
        data: null,
        error: true,
      })
    }
  }, [searchHistory, subjectId, token])

  useEffect(() => {
    fetchSubjectOwnership()
  }, [fetchSubjectOwnership])

  return state
}
